__turbopack_context__.v({
  "aonsatWrap": "NsatRegistrationForm-module-scss-module__rhaH4a__aonsatWrap",
  "chevron": "NsatRegistrationForm-module-scss-module__rhaH4a__chevron",
  "countryCode": "NsatRegistrationForm-module-scss-module__rhaH4a__countryCode",
  "desktopText": "NsatRegistrationForm-module-scss-module__rhaH4a__desktopText",
  "error": "NsatRegistrationForm-module-scss-module__rhaH4a__error",
  "form": "NsatRegistrationForm-module-scss-module__rhaH4a__form",
  "formCard": "NsatRegistrationForm-module-scss-module__rhaH4a__formCard",
  "formDisclaimer": "NsatRegistrationForm-module-scss-module__rhaH4a__formDisclaimer",
  "formHeading": "NsatRegistrationForm-module-scss-module__rhaH4a__formHeading",
  "input": "NsatRegistrationForm-module-scss-module__rhaH4a__input",
  "mobileInput": "NsatRegistrationForm-module-scss-module__rhaH4a__mobileInput",
  "mobileText": "NsatRegistrationForm-module-scss-module__rhaH4a__mobileText",
  "phoneRow": "NsatRegistrationForm-module-scss-module__rhaH4a__phoneRow",
  "select": "NsatRegistrationForm-module-scss-module__rhaH4a__select",
  "selectWrap": "NsatRegistrationForm-module-scss-module__rhaH4a__selectWrap",
  "submitBtn": "NsatRegistrationForm-module-scss-module__rhaH4a__submitBtn",
});
